import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import ProjectEvaluationWidget from '../../../widgets/closeProject/ProjectEvaluationWidget'

import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function ProjectEvaluation(props) {
  //ประเมินผลโครงการ
  const [isEditAll, setIsEditAll] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [showEditAll, setShowEditAll] = useState()

  useEffect(() => {
    setSchemas(mockSchema)
  }, [location.search])
  // const handleGetSchema = async (proposalId) => {
  //   setIsLoading(true)
  //   startLoading()
  //   try {
  //     const _schema = await getAllTargetData(proposalId)
  //     if (_schema.success) setSchemas(_schema.model)
  //   } catch (e) {}
  //   doneLoading()
  //   setIsLoading(false)
  // }

  // useEffect(() => {
  //   console.log('load TargetSettingView project id', projectId)
  //   projectId && handleGetSchema(projectId)
  // }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {showEditAll && <BtnEditAll onClickEditAll={isEditAll} setOnClickEditAll={setIsEditAll} />}

        {schemas?.forms?.projectEvaluation && (
          <>
            <ProjectEvaluationWidget
              showCommandButton={!schemas.forms.projectEvaluation.disabled}
              isEditAll={isEditAll}
              schema={schemas.forms.projectEvaluation}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'ประเมินผลโครงการ',
  subHeader: '',
  forms: {
    projectEvaluation: {
      header: 'ประเมินผลโครงการ',
      buttonText: 'ส่งแบบประเมินผลโครงการ',
      projectEvaluation: {
        name: 'projectEvaluation',
        hint: 'ระบุหมายเหตุประเมินผลโครงการ',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'ประเมินผลโครงการ',
          },
        ],
      },
      attachments: {
        header: 'ไฟล์แนบ',
        buttonText: 'ไฟล์แนบ',
        attachFiles: {
          name: 'attachFiles',
          value: [
            {
              label: 're-name',
              name: 'Log4net.txt',
              path: 'proposal/appendix/D6450F90-5CA8-4235-9C43-DDF7F1C5DAF8.txt',
              type: null,
              size: 0,
              id: '14D8D876-4812-4AAB-9B83-AF440B50B9E0',
            },
            {
              label: 'working_group.jpeg',
              name: 'working_group.jpeg',
              path: 'proposal/appendix/C061EC31-AEB7-474C-856C-E33DD6D3CF5F.jpeg',
              type: null,
              size: 0,
              id: '76066944-8DE3-4586-97B1-14D1404E3333',
            },
            {
              label: '​AIA_CREDIT_CARD.jpg',
              name: '​AIA_CREDIT_CARD.jpg',
              path: 'proposal/appendix/50E1E4F1-112F-47A8-AB91-07B1C516DEDD.jpg',
              type: null,
              size: 0,
              id: 'EDBB1F92-15E6-4CD0-AEA5-A125832CB19B',
            },
          ],
          id: null,
        },
      },
    },
  },
}
